export class AuthAcceptMethods {
  static Default = 'default'
  static Email = 'email'
  static Phone = 'phone'
}
